import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { InvoicingService } from "./invoicing.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { Certificate, CertificateModel, CertificatesContainerModel, CertificateDocumentModel } from "./invoicing";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ApiEndPoints } from "../api.endpoints";
import { ILoggedUser } from "../headerandnavigation/loggeduser/loggeduser";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
  templateUrl: "./invoicingdetail.certificates.component.html"
})
export class InvoicingDetailCertificatesComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Invoicing';
  public invoiceName: string = 'certificates';
  public activeAccountId: string = '';
  public accessAccounts: IAccount[];
  public processAccount: IAccount;
  public certificateList: Certificate[];
  public loggedUser: ILoggedUser;
  public model: CertificatesContainerModel;
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public invoicingService: InvoicingService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    this.processAccount = null;
    this.processAccount = this.accessAccounts[0];
    this.certificatesOnInit();
    const self = this;
    //$(document).on('click', '.DownloadDownloadDocument', function (element) {

    //  let id = $(this).data('id'); //direct get the value
    //  let accountid = $(this).data('accountid'); //direct get the value
    //  self.DownloadDownloadDocumentNew(id, accountid);
    //});
  }

  certificatesOnInit(): void {
    this.loadcertificateList();

  }

  loadcertificateList() {
    this.loaderService.display(true);
    var model: CertificateModel = new CertificateModel();
    model.AccountId = [];
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.CertificatesEndPoint;
    //debugger
    this.accessAccounts.forEach(item => {
      model.AccountId.push(item.id);
    });
    this.invoicingService.getCertificates(model)
      .subscribe(
        (certificates: Certificate[]) => {
          this.certificateList = certificates;
          setTimeout(() => {
            this.afterloaddata();
            this.loaderService.display(false);
          }, 100);
          this.getLoggedUser();
        },
        (error: any) => {
          this.invoicingService.showError("Certificates retrieval problem", <any>error);
          this.loaderService.display(false);
        }
      );
  }

  getLoggedUser() {
    this.loggedUser = this.headerAndNavigationService.getLoggedUser();
    //debugger;
    if (this.loggedUser == null) {
      this.headerAndNavigationService.RedirectToLogin();
    }
    //this.headerAndNavigationService.getLoggedUser()
    //  .subscribe(
    //  (user: ILoggedUser) => {
    //    this.loggedUser = user;
    //    this.loaderService.display(false);
    //  },
    //  (error: any) => {
    //    this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
    //    this.loaderService.display(false);
    //    this.headerAndNavigationService.RedirectToLogin();
    //  }
    //);
  }

  afterloaddata() {
    const self = this;
    $('#certificatedatatable').DataTable({
      //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      //columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }],
      columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0] }, { bSearchable: false, targets: [0, 3] }],
      fixedColumns: true,
      buttons: [
        {
          text: '<button class="btn custom bgBlue" style="padding: 0; width: auto; height: auto; ">Send Request</button >',
          action: function () {
            self.sendRequestClick();
          }
        }
      ]
    });

    //Check All Functionality
    $('#certificatedatatable thead th input[type=checkbox]').change(function () {
      var set = $("#certificatedatatable tbody tr input[type=checkbox]");
      var checked = $(this).is(":checked");
      $(set).each(function () {
        if (checked) {
          $(this).prop("checked", true);
          $(this).parents('tr').addClass("active");
        } else {
          $(this).prop("checked", false);
          $(this).parents('tr').removeClass("active");
        }
      });

    });
    $('#certificatedatatable tbody tr input[type=checkbox]').change(function () {
      $(this).parents('tr').toggleClass("active");
    });

    // DataTable
    var table = $('#certificatedatatable').DataTable();

    // Apply the search
    table.columns().every(function () {
      var that = this;

      $('input', this.footer()).on('keyup change', function () {
        if (that.search() !== this.value) {
          that
            .search(this.value)
            .draw();
        }
      });
    });
  }

  sendRequestClick() {
    let selectedCertificates = this.certificateList.filter(x => x.selected === true);
    if (selectedCertificates.length > 0) {
      this.loaderService.display(true);
      this.model = new CertificatesContainerModel();
      this.model.CertificateDocumentModel = [];
      selectedCertificates.forEach(item => {
        var cModel: CertificateDocumentModel = new CertificateDocumentModel();
          cModel.AccountId = null;//item.accountId;
        cModel.CertificateId = item.id;
        //cModel.EndPointURL = ApiEndPoints.CertificateByIdEndPoint;
          //cModel.EndPointURL = ApiEndPoints.CertificateByIdEndPointNew;
        cModel.Token = this.authService.getToken().access_token;
        this.model.CertificateDocumentModel.push(cModel);
      });
      this.model.Email = this.loggedUser.email;
      this.model.Name = this.loggedUser.firstName + " " + this.loggedUser.lastName;
      this.model.NumberOfFiles = selectedCertificates.length.toString();
      this.model.RequestDate = new Date().toString();
      this.invoicingService.requestCertificateDocuments(this.model)
        .subscribe(
          (status: boolean) => {
            if (status) {
              this.loaderService.display(false);
              $('#modal-requset').modal('show');
            }
            else {
              this.loaderService.display(false);
              this.invoicingService.showError("Certificates: ", "Some problem on request certificate.");
            }
          },
          (error: any) => {
            this.loaderService.display(false);
            this.invoicingService.showError("Certificates", <any>error);
          }
        );
    }
    else {
      this.invoicingService.showInfo("Certificates", "Please select at least one certificate.")
    }
  }

  DownloadDownloadDocument(certificate: Certificate) {
    this.loaderService.display(true);
    var model: CertificateDocumentModel = new CertificateDocumentModel();
    model.CertificateId = certificate.id;
      model.AccountId = null;// certificate.accountId;
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.CertificateByIdEndPoint;
      //model.EndPointURL = ApiEndPoints.CertificateByIdEndPointNew;
    this.invoicingService.getCertificateDocument(model);
  }


  DownloadDownloadDocumentNew(id: any, accountId: any) {
    this.loaderService.display(true);
    var model: CertificateDocumentModel = new CertificateDocumentModel();
    model.CertificateId = id;
    model.AccountId = accountId;
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.CertificateByIdEndPoint;
    this.invoicingService.getCertificateDocument(model);
  }

  ngAfterViewInit(): void {

  }
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicingdetail.certificates.component.ts